export default "__VITE_PUBLIC_ASSET__8ac550e4__"